import React from 'react';

const IconAjakTeman = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.8944 4.05301C6.64741 3.55903 6.04674 3.3588 5.55276 3.60579C5.05878 3.85278 4.85856 4.45345 5.10555 4.94743L5.60555 5.94743C5.85254 6.44141 6.45321 6.64164 6.94719 6.39465C7.44117 6.14766 7.64139 5.54698 7.3944 5.05301L6.8944 4.05301Z"
        fill="#06090D"
      />
      <path
        d="M18.4472 3.60579C17.9533 3.3588 17.3526 3.55903 17.1056 4.05301L16.6056 5.05301C16.3586 5.54698 16.5588 6.14766 17.0528 6.39465C17.5468 6.64164 18.1475 6.44141 18.3945 5.94743L18.8945 4.94743C19.1414 4.45345 18.9412 3.85278 18.4472 3.60579Z"
        fill="#06090D"
      />
      <path
        d="M12.432 9.742C12.2391 9.41087 11.7608 9.41087 11.5679 9.742L10.8177 11.03C10.7471 11.1513 10.6287 11.2373 10.4915 11.267L9.03472 11.5825C8.6602 11.6636 8.51237 12.1185 8.7677 12.4043L9.76082 13.5157C9.85435 13.6204 9.89957 13.7596 9.88543 13.8993L9.73528 15.3822C9.69668 15.7635 10.0837 16.0446 10.4344 15.8901L11.7983 15.2891C11.9268 15.2325 12.0731 15.2325 12.2016 15.2891L13.5655 15.8901C13.9162 16.0446 14.3032 15.7635 14.2646 15.3822L14.1145 13.8993C14.1003 13.7596 14.1455 13.6204 14.2391 13.5157L15.2322 12.4043C15.4875 12.1185 15.3397 11.6636 14.9652 11.5825L13.5084 11.267C13.3712 11.2373 13.2528 11.1513 13.1822 11.03L12.432 9.742Z"
        fill="#06090D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.00021C8.13401 6.00021 5 9.13422 5 13.0002C5 16.8662 8.13401 20.0002 12 20.0002C15.866 20.0002 19 16.8662 19 13.0002C19 9.13422 15.866 6.00021 12 6.00021ZM7 13.0002C7 10.2388 9.23858 8.00021 12 8.00021C14.7614 8.00021 17 10.2388 17 13.0002C17 15.7616 14.7614 18.0002 12 18.0002C9.23858 18.0002 7 15.7616 7 13.0002Z"
        fill="#06090D"
      />
      <path
        d="M20.4453 6.16816C20.9048 5.86181 21.5257 5.98598 21.8321 6.44551C22.1384 6.90504 22.0142 7.52591 21.5547 7.83226L20.0547 8.83226C19.5952 9.13862 18.9743 9.01444 18.668 8.55491C18.3616 8.09538 18.4858 7.47452 18.9453 7.16816L20.4453 6.16816Z"
        fill="#06090D"
      />
      <path
        d="M22 11.0002C22 10.4479 21.5523 10.0002 21 10.0002H20.5C19.9477 10.0002 19.5 10.4479 19.5 11.0002C19.5 11.5525 19.9477 12.0002 20.5 12.0002H21C21.5523 12.0002 22 11.5525 22 11.0002Z"
        fill="#06090D"
      />
      <path
        d="M2.16793 6.44551C2.47429 5.98598 3.09516 5.86181 3.55468 6.16816L5.05468 7.16816C5.51421 7.47452 5.63839 8.09538 5.33203 8.55491C5.02568 9.01444 4.40481 9.13862 3.94528 8.83226L2.44528 7.83226C1.98576 7.52591 1.86158 6.90504 2.16793 6.44551Z"
        fill="#06090D"
      />
      <path
        d="M3 10.0002C2.44772 10.0002 2 10.4479 2 11.0002C2 11.5525 2.44772 12.0002 3 12.0002H3.5C4.05228 12.0002 4.5 11.5525 4.5 11.0002C4.5 10.4479 4.05228 10.0002 3.5 10.0002H3Z"
        fill="#06090D"
      />
    </svg>
  );
};

export default IconAjakTeman;
